<template>
  <div>
    <u-form-radio v-for="(option, index) in options" :key="index"
                  :id="id"
                  v-model="radioValue"
                  @change="$emit('update:modelValue', option.value)"
                  :value="option.value"
                  :name="option.label" />
  </div>
</template>

<script setup>
import {ref, defineEmits} from "vue";
import {defineProps} from 'vue'
const props = defineProps({
  modelValue: String,
  defaultValue: String,
  id: String,
  options: Array,
})

const radioValue = ref(props.defaultValue);
const emit = defineEmits(['update:modelValue'])
emit('update:modelValue', radioValue.value)
</script>
